import { Button, Stack, Typography } from "@mui/joy";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { maestroLogo } from '@utils/assets';

function errorForStatus(status?: number) {
    if(status === 404) {
        return 'The page you are looking for could not be found.';
    }

    if(status === 401 || status === 403) {
        return 'You do not have permission to view this page.';
    }

    if(status === 503) {
        return 'There is an error with our server. Please check back soon.';
    }

    return 'An unknown error has occurred.';
}

export default function UnrecoverableError({ status = null, message = '' }) {
    const error = status || useRouteError();
    const errorStatus = status || error?.status;

    return <Error>{errorForStatus(errorStatus)}</Error>
}

export function Error({children}) {
    return (
        <Stack alignItems={'center'} justifyContent={'center'} height={'100%'} className="unrecoverable-error">
            <Stack gap={4} alignItems={'center'}>
                <img
                    src={maestroLogo}
                    alt="Maestro Logo"
                    style={{width: '300px', minWidth: '100px'}}
                />
                <Typography level="body-sm" textAlign={'center'}>
                    {/* {isRouteErrorResponse(error) === true && errorForStatus(error?.status)} */}
                    {/* {isRouteErrorResponse(error) !== true && errorForStatus(undefined)} */}
                    {/* {errorForStatus(errorStatus)} */}
                    {/* {typeof children === 'string' ? <></>children} */}
                    <>{children}</>
                    <br/>
                    If you keep experiencing this error, please contact support.
                </Typography>
                <Button component="a" href="https://www.maestrocm.com/support/" target="_blank" sx={{':hover': {color: 'white'}}}>Contact Support</Button>
            </Stack>

        </Stack>
    );
}

